import React, { useEffect, useState } from "react"
import styled from "styled-components"
import SimpleFormInput from "../components/SimpleFormInput"
import Footer from "../components/Footer"
import { AiFillStar } from "react-icons/ai"
import ProductCard from "../components/ProductCard"
import PrimaryBtn from "../components/PrimaryBtn"
import { getAuth, updateProfile } from "firebase/auth"
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore"
import { ref, uploadBytes, getDownloadURL, getStorage } from "firebase/storage"
import { db, useAuth } from "../firebase-config"
import { toast, ToastContainer } from "react-toastify"
import ImageInputBtn from "../components/ImageInputBtn"
import { Link } from "react-router-dom"

const Profile = () => {
  let profilePicture =
    "https://www.seekpng.com/png/detail/966-9665317_placeholder-image-person-jpg.png"
  const [loading, setLoading] = useState(false)
  const currentUser = useAuth()
  const [name, setName] = useState("")
  const [profileDetailsData, setProfileDetailsData] = useState(null)
  const [shopName, setShopName] = useState("")
  const [countryName, setCountryName] = useState("")
  const [coverBaseString, setCoverBaseString] = useState(
    "https://images.unsplash.com/photo-1497100022365-1a3688dc53ec?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8"
  )
  // const [loading, setLoading] = useState(false);
  const [coverImage, setCoverImage] = useState("")
  const [imgUploadPrg, setImgUploadPrg] = useState(false)
  const [profilePic, setProfilePic] = useState("")
  const [coverEditPrg, setCoverEditPrg] = useState("Edit")
  const [myProductList, setMyProductList] = useState([])
  const [referralCode, setReferralCode] = useState("")
  let personalInfo = {
    name: name ? name : profileDetailsData?.name,
    shopName: shopName,
    countryName: countryName,
  }

  console.log(countryName)

  const updateUserProfile = async () => {
    console.log("start")
    let terms = {
      newsletter: false,
      articleLikeAlert: false,
      feedPersonalize: false,
      profileData: false,
    }
    if (!shopName) {
      toast.warning("shop Name is Required")
      console.log("in if")
    } else {
      try {
        console.log("try")

        setLoading(true)
        const profileRef = doc(db, "users", currentUser.uid)
        await setDoc(
          profileRef,
          {
            personalInfo,
            coins: 0,
            following: [],
            orders: [],
            subscription: "gold",
            uid: currentUser.uid,
            terms,
          },
          { merge: true }
        )
        toast.success("Profile Updated")
        setLoading(false)
      } catch (error) {
        setLoading(false)
        console.log(error)
      }
    }
  }

  const updateCover = async () => {
    try {
      setCoverEditPrg("Saving...")
      setLoading(true)
      const profileRef = doc(db, "users", currentUser.uid)
      await updateDoc(profileRef, {
        shopCover: coverImage,
      })
      toast.success("Cover Updated")
      setLoading(false)
      setCoverEditPrg("Edit")
    } catch (error) {
      setCoverEditPrg("Edit")
      setLoading(false)
      console.log(error)
    }
  }

  const uploadProfilePic = async photoUrl => {
    const profileRef = doc(db, "users", currentUser.uid)
    try {
      setImgUploadPrg(true)
      await setDoc(profileRef, { ...profileDetailsData, photoUrl })
      toast.success("Profile Picture Changed")
      setImgUploadPrg(false)
    } catch (error) {
      setImgUploadPrg(false)
      console.error(error)
    }
  }

  const fetchProfileDetails = async () => {
    const profileRef = doc(db, "users", currentUser?.uid)
    const resp = await getDoc(profileRef)
    if (resp.exists()) {
      let personalInf = resp.data()
      setCoverBaseString(personalInf.shopCover)
      setProfileDetailsData(personalInf.personalInfo)
    }
  }


  console.log(profileDetailsData)
  const uploadProfileImage = file => {
    const auth = getAuth()
    const storage = getStorage()
    const storageRef = ref(storage, `profileUrl/${auth.currentUser.uid}`)
    const uploadTask = uploadBytes(storageRef, file, { contentType: file.type })
      .then(snapshot => {
        setImgUploadPrg((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
      })
      .then(() =>
        getDownloadURL(storageRef).then(url => {
          updateProfile(auth.currentUser, {
            photoURL: url,
          })
          console.log(url)
        })
      )
      .catch(error => console.log(error))
  }

  const selectImage = e => {
    let profilefile = e.target.files[0]
    var reader = new FileReader()
    reader.onloadend = function () {
      setProfilePic(reader.result)
    }
    reader.readAsDataURL(e.target.files[0])
    if (profilefile) {
      setTimeout(() => {
        uploadProfileImage(profilefile)
      }, 0)
    }
  }

  const fetchProduct = async () => {
    try {
      const q = query(
        collection(db, "products"),
        where("shopId", "==", `shop/${currentUser?.uid}`)
      )
      const querySnapshot = await getDocs(q)

      setMyProductList(querySnapshot.docs.map(doc => ({ ...doc.data() })))
    } catch (error) {
      console.error(error)
    }
  }

  const selectCoverImage = e => {
    setCoverEditPrg("Editing")
    let file = e.target.files[0]
    let reader = new FileReader()
    reader.onloadend = function () {
      setCoverImage(reader.result)
      setCoverBaseString(reader.result)
      setCoverEditPrg("Save")
    }
    reader.readAsDataURL(file)
  }

  const referFriend = () => {
    let code = `${profileDetailsData?.name}${Math.floor(Math.random()) * 230}`
    setReferralCode(code)
    var copyText = document.getElementById("refercode")
    copyText?.select()
    copyText?.setSelectionRange(0, 99999)
    navigator.clipboard.writeText(copyText?.value)
    toast.success("Copied to clipboard")
  }

  useEffect(() => {
    fetchProfileDetails()
    fetchProduct()
    return fetchProfileDetails
  }, [currentUser?.uid])

  useEffect(() => {
    setName(profileDetailsData?.persoalInfo?.name)
    setCountryName(profileDetailsData?.persoalInfo?.country)
    setShopName(profileDetailsData?.persoalInfo?.shopName)
  }, [profileDetailsData])

  return (
    <>
      <ToastContainer limit={1} position="top-center" />
      <ProfileWrap>
        <CoverSection
          url={`url(${coverBaseString ? coverBaseString : coverImage})`}
        >
          <HorizontalYellLine></HorizontalYellLine>
          <ActionBtn>
            {coverEditPrg === "Edit" || coverEditPrg === "Editing" ? (
              <ImageInputBtn
                btnLabel={coverEditPrg}
                handleOnChange={selectCoverImage}
              />
            ) : (
              <PrimaryBtn handleBtn={updateCover} label={coverEditPrg} />
            )}
          </ActionBtn>
        </CoverSection>
        <ProfileDetailSec>
          <div className="element_one">
            {profilePic ? (
              <img
                className="profile_pic"
                src={profilePic}
                alt="profile picture"
              />
            ) : (
              <img
                className="profile_pic"
                src={
                  currentUser.photoURL ? currentUser.photoURL : profilePicture
                }
                alt="profile picture"
              />
            )}
            <div className="file-input">
              <input
                type="file"
                id="profilefile"
                accept="image/*"
                onChange={selectImage}
                className="profilefile"
              />
              <label htmlFor="profilefile">Select file</label>
            </div>
            {referralCode && (
              <input
                type="text"
                value={referralCode}
                className="refercode"
                id="refercode"
                disabled
              />
            )}
            <PrimaryBtn handleBtn={referFriend} label="Refer Friend" />
          </div>
          <div className="element_two">
            <SimpleFormInput
              disabled={true}
              btnLabel={"Edit"}
              value={name ? name : profileDetailsData?.name}
              handleOnChange={e => setName(e.target.value)}
              label={"Name"}
              placeholder={"Name"}
            />
            <SimpleFormInput
              disabled={false}
              btnLabel={"Edit"}
              value={shopName ? shopName : profileDetailsData?.shopName}
              handleOnChange={e => setShopName(e.target.value)}
              label={"Shop Name"}
              placeholder={"Shop Name"}
            />
           
           
            {/* <SimpleFormInput
              btnLabel={""}
              placeholder={"Follow: @00 "}
              label={"Follow: @00 peoples"}
            /> */}
            <SimpleFormInput btnLabel={""} label={"Discounts on lots"} />
            <SimpleFormInput
              type="color"
              btnLabel={"Change"}
              label={"Background Color"}
            />
            <SimpleFormInput btnLabel={""} label={"Shop Policy"} />
            <SimpleFormInput
              label={"Shop Policy Color"}
              btnLabel={"Change"}
              value={""}
            />
            <SimpleFormInput
              label={"Country"}
              btnLabel={"Edit"}
              value={countryName ? countryName : profileDetailsData?.countryName}
              handleOnChange={e => setCountryName(e.target.value)}
            />
            <div>
              <PrimaryBtn
                handleBtn={updateUserProfile}
                label={loading ? "Saving..." : "Save"}
              />
            </div>
          </div>
        </ProfileDetailSec>
      </ProfileWrap>
      <ProductsSliderContainer>
        <SliderOption>
          <label className="slider_title">My Products</label>
          <ViewBtn to="/productlist">View All</ViewBtn>
        </SliderOption>
        <SliderList>
          {myProductList.map((item, index) => {
            return (
              <ProductCard
                key={index}
                linkTo={`productdetail/:${item.id}`}
                productImage={item.productPhoto}
                productPrice={item.productDetails?.originalPrice}
                sellerName={""}
                isAuctionCard={false}
                productName={item.productDetails?.productName}
                setWidth={"10rem"}
                setHeight={"385px"}
                imgHeight={"234px"}
                imgWidth={"10rem"}
              />
            )
          })}
        </SliderList>
      </ProductsSliderContainer>
      <Footer />
    </>
  )
}

export default Profile

const ProfileWrap = styled.div`
  display: flex;
  flex-direction: column;
`
const CoverSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  background: ${({ url }) => url};
  height: 30rem;
  background-size: cover;
  position: relative;
`
const HorizontalYellLine = styled.div`
  display: flex;
  background: #ffcc48;
  height: 1.5rem;
  width: 100%;
`
const ActionBtn = styled.div`
  position: absolute;
  border: none;
  padding: 0.8rem 1rem;
  color: var(--white);
  font-size: 0.8rem;
  font-family: Montserrat;
  font-weight: 600;
  right: 2rem;
  bottom: 2rem;
  cursor: pointer;
  background: var(--black-shade);
`
const ProfileEditBtn = styled.input`
  border: none;
  padding: 0.8rem 2rem;
  max-height: 3rem;
  max-width: 2rem;
  color: var(--white);
  font-size: 0.8rem;
  font-family: Montserrat;
  font-weight: 600;
  cursor: pointer;
  background: ${({ theme }) => theme.accent};
`

const ProfileDetailSec = styled.div`
  display: flex;
  height: 50rem;
  margin: 1rem 0;
  @media (max-width: 768px) {
    height: 60rem;
  }
  .element_one {
    display: flex;
    flex-direction: column;
    height: 30%;
    width: 20%;
    justify-content: space-evenly;
    max-width: 20%;
    align-items: center;
    .profile_pic {
      width: 4rem;
      height: 4rem;
      border-radius: 100%;
      border: 2px solid #ffcc48;
    }

    .refrralcode {
      outline: none;
      border: none;
      margin-left: 0.5rem;
      width: fit-content;
    }

    .profilefile {
      opacity: 0;
      width: 0.1px;
      height: 0.1px;
      position: absolute;
    }
    .file-input label {
      position: relative;
      width: 100px;
      height: 50px;
      background: ${({ theme }) => theme.accent};
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      cursor: pointer;
    }
  }

  .element_two {
    display: flex;
    flex-direction: column;
    height: 90%;
    width: 80%;
    padding: 0rem 2rem;
    justify-content: space-evenly;
    align-items: center;
  }
`
const InputWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  /* align-items: center; */
  background: ${({ theme }) => theme.background};
  border-radius: 5px;
  margin: 5px 0px;

  .input_header_cont {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-top: 1rem;
  }

  .label_cont {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  label,
  p {
    padding: 0rem 1rem;
    color: ${({ theme }) => theme.secondryText};
    font-size: 0.8rem;
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
  }
`

const InputField = styled.input`
  width: 85%;
  height: 2.5rem;
  background: none;
  border: none;

  :focus {
    outline: none;
  }
`
const InputActionBtn = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.secondryText};
  font-size: 0.8rem;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  cursor: pointer;
`

const ProductsSliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0rem 2rem;
  margin: 2rem 0rem;
  .sliderStyle {
    height: 20vh;
  }
`

const SliderOption = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  .slider_title {
    font-size: 1.5rem;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
  }
`

const SliderList = styled.div`
  display: flex;
  margin-top: 1rem;
  overflow-x: auto;
  ::-webkit-scrollbar {
    width: 0px;
  }
`

const ViewBtn = styled(Link)`
  background: none;
  border: none;
  font-family: Montserrat;
  text-decoration: none;
  font-style: normal;
  font-weight: normal;
  font-size: 0.8rem;
  text-align: right;
  color: #747178;
  cursor: pointer;
`
